import {
  DecoratorNode,
  NodeKey,
  SerializedLexicalNode,
  Spread,
  LexicalEditor,
} from "lexical";
import { JSX } from "react";
import { HtmlDecorator } from "./HtmlDecorator";

export type SerializedHtmlNode = Spread<
  { html: string; type: "signature"; version: 1 },
  SerializedLexicalNode
>;

export class HtmlNode extends DecoratorNode<JSX.Element> {
  __html: string;

  static getType(): string {
    return "signature";
  }

  static clone(node: HtmlNode): HtmlNode {
    return new HtmlNode(node.__html, node.__key);
  }

  static importJSON(s: SerializedHtmlNode): HtmlNode {
    return new HtmlNode(s.html);
  }

  constructor(html: string, key?: NodeKey) {
    super(key);
    this.__html = html;
  }

  exportJSON(): SerializedHtmlNode {
    return {
      html: this.__html,
      type: "signature",
      version: 1,
    };
  }

  // Used when editor exports to HTML (e.g. sending the email)
  exportDOM(_editor: LexicalEditor): { element: HTMLElement } {
    const div = document.createElement("div");
    div.innerHTML = this.__html;
    return { element: div };
  }

  // Update the stored HTML and trigger re-render
  setHTML(html: string): void {
    const self = this.getWritable();
    self.__html = html;
  }

  isInline(): boolean {
    return false;
  }

  createDOM(): HTMLElement {
    return document.createElement("div");
  }

  updateDOM(): false {
    return false;
  }

  decorate(): JSX.Element {
    return <HtmlDecorator nodeKey={this.__key} html={this.__html} />;
  }
}
